import {ConnectedComponent,sharedComponent} from 'lowkey-component'

import {colors} from '@services/utils'
import {appSelectors} from '@store/appSlice'
import {navSelectors} from '@store/navSlice'

@sharedComponent
export class Header extends ConnectedComponent {
  private svg: SVGSVGElement | undefined = undefined

  didMount() {
    this.svg = this.element.querySelector('svg') as SVGSVGElement
    this.observe(appSelectors.selectPageIndicatorStatus, async (status) => {
      if (status === 'startHideAnimation') {
        this.element?.classList.add('viewed')
      } else if (status === 'startShowAnimation') {
       this.svg && (this.svg.style.fill = '')
      }
    })
    this.observe(navSelectors.selectIsShowHeaderNavMenu, async (isShow) => {
      if (this.svg) {
        if (isShow) {
          this.svg.style.fill = colors.white
        } else {
          this.svg.style.fill = ''
        }
      }
    })
    this.observe(navSelectors.selectHeaderNavDisplayState, (state) => {
      switch (state) {
        case 'hide':
          this.element.classList.add('hide')
          this.element.classList.remove('show')
          return
        case 'show':
          this.element.classList.add('show')
          this.element.classList.remove('hide')
          return
        case undefined:
          this.element.classList.remove('hide')
          this.element.classList.remove('show')
          return
      }
    })
  }
}
